import { render, staticRenderFns } from "./apiCate.vue?vue&type=template&id=243ec032&scoped=true"
import script from "./apiCate.vue?vue&type=script&lang=js"
export * from "./apiCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243ec032",
  null
  
)

export default component.exports